import React from 'react';
import WhatsAppEditorWrapper from '../../../../pages/branding/whatsAppScreen/WhatsAppEditorWrapper';
import WhatsAppImage from '../../../../pages/branding/whatsAppScreen/WhatsAppImage';
import * as css from './WhatsAppTab.css';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store.type';
import {removeTagsFromText} from '../../../../pages/branding/emailSubjectTextEditor/EmailSubjectTextEditor';
import {uploadFile} from '../../../../redux/user/userActions';
import {TWhatsAppProps} from '../../types';

const WhatsAppTab = ({image = {path: '', imageId: ''},text,whatsappTemplate,saveImage,saveText, whatsappPrefix, whatsappSuffix, whatsappButtons, maxLines}: TWhatsAppProps) => {
    const lang = useSelector((s: RootState) => s.user.lang);
    const uid = useSelector((s: RootState) => s.user.uid);
    
    const handleImageSave = async (newImage) => {
        if(newImage?.image){
            saveImage(await uploadFile(newImage.image, '', 'whatsappImage', uid));
        }
    };
    const handleSaveText = (content) =>{
        content = content.replace(/<\/p><p>/g, '\n');
        const cleanText = removeTagsFromText(content);
        
        saveText(cleanText);
    };
    const defaultText = text?.replace(/\\n|\n/g, '</p><p>');

    return (
        <>
            <WhatsAppImage
                image={image}
                saveImage={handleImageSave}
            />
            <css.editorSection>
                <WhatsAppEditorWrapper
                    defaultText={defaultText}
                    dependencies={[lang]}
                    events={{onChange: handleSaveText}}
                    whatsappTemplate={whatsappTemplate}
                    limit={undefined}
                    variablesType={whatsappTemplate}
                    whatsappPrefix={whatsappPrefix}
                    whatsappSuffix={whatsappSuffix}
                    whatsappButtons={whatsappButtons}
                    maxLines={maxLines}
                />
            </css.editorSection>
        </>
    );
};

export default WhatsAppTab;
